module.exports = __webpack_public_path__ + "img/macbook.18f00b5a.svg";